module.exports = __webpack_public_path__ + "img/SebastienVanParys_140x140_rund.932a010e.jpg";